import { logger as browserLogger } from '@/logger/logger.browser';

export async function checkEligibility() {
  try {
    const resp = await fetch('/api/checkEligibility', { method: 'POST' });

    if (!resp.ok) {
      browserLogger.warn('checkEligibility returned a non-ok response', {
        status: resp.status,
      });
      return undefined;
    }

    return await resp.json();
  } catch (error) {
    browserLogger.warn('Error calling checkEligibility', {
      error,
    });
  }
}
